// extracted by mini-css-extract-plugin
export var container = "key-figure-module--container--88ba0";
export var containerSmaller = "key-figure-module--containerSmaller--de685";
export var icon = "key-figure-module--icon--4c112";
export var keyContainer = "key-figure-module--keyContainer--fa0ae";
export var number = "key-figure-module--number--03687";
export var subtitle = "key-figure-module--subtitle--f1957";
export var symbol = "key-figure-module--symbol--3ee10";